/** Which settings section is open. Sub-pages read it to send the user to another one. */
export const TAB_PARAM = 'tab';

export const ROLE_PARAM = 'role';
